<template>
  <Dialog :open="open" @update:open="onOpenChange">
    <DialogScrollContent size="lg">
      <DialogHeader>
        <DialogTitle>
          {{ $t("Select date") }}
        </DialogTitle>
      </DialogHeader>

      <SlotSelector
        v-if="mode === 'slot'"
        :stages="stages"
        :booking="booking"
        @slotSelected="emit('stage-slot', $event)"
      >
      </SlotSelector>
      <StoreDateSelector
        v-else-if="mode === 'store'"
        :booking="booking"
        :api-url="apiUrl"
        @changeStoreSlot="emit('stage-store-slot', $event)"
      >
      </StoreDateSelector>
      <EquipmentCalendar
        v-else
        :timezone="timezone"
        :booking="booking"
        :default-start-time="defaultStartTime"
        :default-end-time="defaultEndTime"
        @change="emit('stage-range', $event)"
      >
      </EquipmentCalendar>

      <DialogFooter>
        <button type="button" class="btn btn-primary" @click.prevent="emit('save')">
          {{ $t("Save dates") }}
        </button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import SlotSelector from "@/components/booking/SlotSelector.vue";
import StoreDateSelector from "@/components/booking/StoreDateSelector.vue";
import EquipmentCalendar from "@/components/booking/EquipmentCalendar.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    required: true
  },
  booking: {
    type: Object,
    default: null
  },
  stages: {
    type: Array,
    default: () => []
  },
  timezone: {
    type: String,
    required: true
  },
  defaultStartTime: {
    type: String,
    default: null
  },
  defaultEndTime: {
    type: String,
    default: null
  },
  apiUrl: {
    type: String,
    default: null
  }
});

const emit = defineEmits([
  "update:open",
  "stage-range",
  "stage-store-slot",
  "stage-slot",
  "save",
  "discard"
]);

/** Closing without saving must leave the submitted dates untouched. */
function onOpenChange(isOpen) {
  if (!isOpen) {
    emit("discard");
  }

  emit("update:open", isOpen);
}
</script>
